module.exports = __webpack_public_path__ + "img/ci.3ff2bcbf.svg";